import { curry } from '@gaia/util'
import session from 'app/_shared/session';

/**
 * Team getter
 */
// eslint-disable-next-line no-unused-vars
export default curry((module, _) => () => session(module).team.key({ wrap: false }))
